import styled, { css } from 'styled-components';
import { mobile_xl } from '../../../../global/mediaQueryMixin';
import { FlexCenter } from '../../../../global/commonStyle';

export const RightSection = styled.div`
  display: none;
  .dropdown-content {
    position: absolute;
    z-index: var(--z-index-toast);
    top: 30px;
    right: 45px;
    ${mobile_xl(css`
      right: 0;
    `)}
  }
`;

export const RightIcons = styled.div`
  display: flex;
  position: absolute;
  right: 0;
  left: auto;
  top: -24px;
  z-index: var(--z-index-111);
  background: var(--background-primary);
  padding: var(--space-4);
  gap: var(--space-4);
  border: 0.5px solid var(--border-primary);
  box-shadow: var(--shadow-modal);
  border-radius: var(--border-radius-full);
  .active {
    border-radius: var(--border-radius-full);
    background-color: var(--background-muted);
  }
  ${mobile_xl(css`
    top: -40px;
  `)}
`;

export const ReactionDiv = styled.div`
  position: relative;
`;

export const EmojiDiv = styled.div`
  ${FlexCenter}
  font-size: 14px;
  width: 16px;
  height: 16px;
  padding: var(--space-4);
  cursor: pointer;
  &:hover {
    background-color: var(--background-muted);
    border-radius: var(--border-radius-full);
  }
  ${mobile_xl(css`
    padding: var(--space-8);
    width: 20px;
    height: 20px;
  `)}
`;
